
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class WLProductMoreDetails extends Vue {
  @Prop()
  private content!: string;
  @Prop()
  private title!: string;
  @Prop()
  private color!: string;

  private isOpen = false;

  setIsOpen() {
    this.isOpen = !this.isOpen
  };

}
